




// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import Login from "@/components/login.vue";

@Component({
  name: "LoginPage",
  components: {
    Login,
  },
})
export default class LoginPage extends Vue {}
